const state = {
  companyData: {},
  customerData: {},
  serviceList: []
};

export default {
  state
};
